import { Layout } from './CoreComponents';
import MasLogo from '../images/MAS.png';
import { useSelector } from 'react-redux';
import { RootState } from '../store/index';
import { UserDashboard } from './Dashboard/UserDashboard';
import { AdminDashboard } from './Dashboard/AdminDashboard';
import { PurchaserDashboard } from './Dashboard/PurchaserDashboard';
import { USER_ROLES } from '../constants';

const DashboardPage = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const renderDashboard = () => {
    if (!user) return null;

    switch (user.role) {
      case USER_ROLES.USER:
        return <UserDashboard />;
      case USER_ROLES.ADMIN:
        return <AdminDashboard />;
      case USER_ROLES.PURCHASER:
        return <PurchaserDashboard />;
      default:
        return <UserDashboard />;
    }
  };

  return (
    <Layout currentScreen="dashboard">
      {/* Welcome Header */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Hoş geldiniz, {user?.fullName || 'Kullanıcı'}
            </h1>
          </div>
          <div className="flex items-center">
            <img 
              src={MasLogo} 
              alt="MAS" 
              className="h-12 w-auto"
            />
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      {renderDashboard()}
    </Layout>
  );
};

export default DashboardPage;
